export const SPICECLUB_DETAILS='SPICECLUB_DETAILS';